import {getComparableTemplateName} from 'lib/ReportUtil';
import get from 'lodash/get';

export const makeComparablePropertySection = (s) => {
  const template = getComparableTemplateName(s.key, 4);
  return {
    name: s.key,
    title: get(s, 'sectionData.title'),
    pdf: s.url,
    template,
    data: {
      ...s.sectionData,
    }
  };
};